import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent.vue?vue&type=template&id=39e934fb"
import script from "./RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports